import React, { useEffect, useState } from "react";

import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer';
import { LinePlot, MarkPlot } from '@mui/x-charts/LineChart';
import { BarPlot } from '@mui/x-charts/BarChart';
import { ChartsXAxis } from '@mui/x-charts/ChartsXAxis';
import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis';
import { ChartsGrid } from '@mui/x-charts/ChartsGrid';
import { ChartsTooltip } from '@mui/x-charts/ChartsTooltip';
import { fetchStockAllPart } from '../../resources/AnalyticReportResource';

const series = [
  { type: 'line', dataKey: 'standart_stock', color: '#00DD9A', label: 'Standard (pcs)' },
  { type: 'line', dataKey: 'current_stock', color: '#FFB800', label: 'Current (pcs)' },
  { type: 'bar', dataKey: 'usage_percentage', color: '#000A6A', yAxisKey: 'rightAxis', label: 'Usage (%)' },
];

export default function StockPartOverview() {

  const [dataStockAllPart, setDataStockAllPart] = useState(null);

  const fetchDataStockAllPart = () => {
    fetchStockAllPart()
      .then((res) => {
        setDataStockAllPart(res.data);
      })
      .catch((err) => {
        setDataStockAllPart([]);
      });
  };

  useEffect(() => {
    fetchDataStockAllPart();
  }, []);

  return (
    <div>
      {!dataStockAllPart ? <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '260px'
      }}>
        <div className="spinner-border text-primary" role="status"> <span className="visually-hidden">Loading...</span>
        </div>
      </div> : dataStockAllPart.length === 0 ? <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '260px'
      }}>
        <div><span>Data is Empty</span></div>
      </div> :
        <ResponsiveChartContainer
          series={series}
          dataset={dataStockAllPart}
          sx={{ overflowX: 'scroll' }}
          xAxis={[
            {
              scaleType: 'band',
              dataKey: 'part_name',
            }
          ]}
          yAxis={[
            { id: 'leftAxis' },
            { id: 'rightAxis' },
          ]}
          height={400}
        >
          <ChartsGrid horizontal />
          <BarPlot />
          <LinePlot />
          <MarkPlot />

          <ChartsXAxis />
          <ChartsYAxis axisId="leftAxis" />
          <ChartsTooltip />
        </ResponsiveChartContainer>
      }
    </div>
  );
}